import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationComponent } from "./pagination.component";
import {NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {SharedModule} from "../../../modules/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxPopperModule} from "ngx-popper";
import {ValidateModule} from "../../modules/validate/validate.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {IconsModule} from "../icons/icons.module";



@NgModule({
  declarations: [
    PaginationComponent
  ],
  exports: [
    PaginationComponent
  ],
  imports: [
    CommonModule,
    NgbPaginationModule,
    SharedModule,
    ReactiveFormsModule,
    NgxPopperModule,
    ValidateModule,
    NgSelectModule,
    FormsModule,
    IconsModule
  ]
})
export class PaginationModule { }
